module.exports = __webpack_public_path__ + "img/btn-close.f5a2f904.svg";